import _ from 'underscore';

function Ctrl($scope, $state, utilsService, jsSdkConfig) {
  const banners = [];

  banners.push({
    src: 'cbs',
    message: 'Welcome Columbia Business School! You get to skip the application line. Your first month is free when you enter the code <strong>CBS</strong> at checkout.',
    link: {
      url: 'https://www.tablelist.com/membership/start?src=bsc',
      text: 'GET STARTED'
    }
  });

  banners.push({
    src: 'ivyholiday16',
    message: 'Welcome IVY Members! Skip the application line and receive Platinum Membership at $29/month. Enter <strong>IVYHOLIDAY29</strong> at checkout.',
    states: ['membership', 'membership.start'],
    link: {
      url: 'https://www.tablelist.com/membership/start?src=ivyholiday16',
      text: 'GET STARTED'
    }
  });

  const _subclient = jsSdkConfig.subClient || 'www';

  $scope.promo = _.find(banners, {
    src: _subclient
  });

  $scope.dismissed = false;

  $scope.showPromoBar = function() {
    if ($scope.dismissed) {
      return false;
    }

    if (_.isUndefined($scope.promo)) {
      return false;
    }

    if (!$scope.promo.states || $scope.promo.states.length < 1) {
      return true;
    }

    if ($scope.promo.states.length > 1) {
      return _.reduce($scope.promo.states, function(result, state) {
        return result || $state.includes(state);
      }, false);
    }

    return $state.includes('app.browse') || $state.includes('app.me') || $state.is('app.home');
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  'utilsService',
  'jsSdk.config'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/promoBar/controller.js